var cov_14mv49utib = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Card/Header.tsx",
      hash = "331ac6422d96296f9f5c1d0064574a41bc4ca134",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Card/Header.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 26
        },
        end: {
          line: 10,
          column: 36
        }
      },
      "1": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 49
        }
      },
      "2": {
        start: {
          line: 11,
          column: 33
        },
        end: {
          line: 11,
          column: 49
        }
      },
      "3": {
        start: {
          line: 12,
          column: 22
        },
        end: {
          line: 12,
          column: 44
        }
      },
      "4": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 64
        }
      },
      "5": {
        start: {
          line: 17,
          column: 73
        },
        end: {
          line: 17,
          column: 83
        }
      },
      "6": {
        start: {
          line: 19,
          column: 25
        },
        end: {
          line: 19,
          column: 99
        }
      },
      "7": {
        start: {
          line: 20,
          column: 20
        },
        end: {
          line: 20,
          column: 75
        }
      },
      "8": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 27,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 3
          }
        },
        loc: {
          start: {
            line: 9,
            column: 20
          },
          end: {
            line: 14,
            column: 3
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 3
          }
        },
        loc: {
          start: {
            line: 16,
            column: 11
          },
          end: {
            line: 28,
            column: 3
          }
        },
        line: 16
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 11,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 11,
            column: 49
          }
        }, {
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 11,
            column: 49
          }
        }],
        line: 11
      },
      "1": {
        loc: {
          start: {
            line: 19,
            column: 63
          },
          end: {
            line: 19,
            column: 86
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 63
          },
          end: {
            line: 19,
            column: 70
          }
        }, {
          start: {
            line: 19,
            column: 74
          },
          end: {
            line: 19,
            column: 86
          }
        }],
        line: 19
      },
      "2": {
        loc: {
          start: {
            line: 20,
            column: 20
          },
          end: {
            line: 20,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 53
          },
          end: {
            line: 20,
            column: 63
          }
        }, {
          start: {
            line: 20,
            column: 66
          },
          end: {
            line: 20,
            column: 75
          }
        }],
        line: 20
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Card/Header.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import icons from '../icons';
import { cardClass } from './styles';
import { isRTL } from '../config';

var Header =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Header, _PureComponent);

  var _super = _createSuper2(Header);

  function Header() {
    _classCallCheck(this, Header);

    return _super.apply(this, arguments);
  }

  _createClass(Header, [{
    key: "renderIndicator",
    value: function renderIndicator() {
      cov_14mv49utib.f[0]++;

      var _ref = (cov_14mv49utib.s[0]++, this.props),
          collapsed = _ref.collapsed;

      cov_14mv49utib.s[1]++;

      if (collapsed === undefined) {
        cov_14mv49utib.b[0][0]++;
        cov_14mv49utib.s[2]++;
        return undefined;
      } else {
        cov_14mv49utib.b[0][1]++;
      }

      var className = (cov_14mv49utib.s[3]++, cardClass('indicator'));
      cov_14mv49utib.s[4]++;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          className: className,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 13,
            columnNumber: 12
          }
        }, icons.AngleRight)
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_14mv49utib.f[1]++;

      var _ref2 = (cov_14mv49utib.s[5]++, this.props),
          style = _ref2.style,
          align = _ref2.align,
          className = _ref2.className,
          children = _ref2.children,
          onCollapse = _ref2.onCollapse,
          collapsed = _ref2.collapsed;

      var newClassName = (cov_14mv49utib.s[6]++, classnames(cardClass('header', align, (cov_14mv49utib.b[1][0]++, isRTL()) && (cov_14mv49utib.b[1][1]++, 'header-rtl')), className));
      var onClick = (cov_14mv49utib.s[7]++, typeof collapsed === 'boolean' ? (cov_14mv49utib.b[2][0]++, onCollapse) : (cov_14mv49utib.b[2][1]++, undefined));
      cov_14mv49utib.s[8]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          style: style,
          onClick: onClick,
          className: newClassName,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 23,
            columnNumber: 7
          }
        }, this.renderIndicator(), children)
      );
    }
  }]);

  return Header;
}(PureComponent);

export default Header;